var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.394,
    height: 42.877,
    viewBox: "0 0 40.394 42.877",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1358",
    "data-name": "Group 1358",
    transform: "translate(-1292.46 -341.465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8717",
    "data-name": "Path 8717",
    d: "M1482.748,211.051a20.2,20.2,0,1,1-20.2-20.2,20.2,20.2,0,0,1,20.2,20.2",
    transform: "translate(-149.894 153.094)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8718",
    "data-name": "Path 8718",
    d: "M1482.748,204.413a20.2,20.2,0,1,1-20.2-20.2,20.2,20.2,0,0,1,20.2,20.2",
    transform: "translate(-149.894 157.249)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8719",
    "data-name": "Path 8719",
    d: "M1491.079,226.9l-7.614-6.108,6.663-6.319-3.154-3.325-7.117,6.749-7.734-6.2-2.867,3.574,7.245,5.812-7.154,6.785,3.154,3.325,7.609-7.216,8.1,6.5Z",
    transform: "translate(-166.732 140.388)",
    fill: "#868686"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/close-btn.2ad9e34a1dd0e820ceeccf9c84277097.svg";
export { ForwardRef as ReactComponent };